import { CategoriesEditor } from '../CategoriesEditor'

export function StepCategories({ accountId }) {
  return (
    <div className="onboarding-step">
      <h2>Step 2 — Categories &amp; business context</h2>
      <p className="step-hint">
        Tell the AI what kind of contacts matter to you. You can keep the defaults and refine later.
      </p>
      {accountId ? (
        <div className="categories-panel">
          <CategoriesEditor accountId={accountId} onClose={() => {}} />
        </div>
      ) : (
        <div className="message error">No account found. Please go back to step 1.</div>
      )}
    </div>
  )
}
